import { render } from "./ContactsView.vue?vue&type=template&id=ed914eb8&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=ed914eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed914eb8"]])

export default __exports__